import React, { useCallback } from 'react';
import clsx from 'clsx';
import { coverAiUpsellAlwaysShown } from 'fym-shared/src/music24/coverEditorPlans';
import { TypedMemo } from '../../common/types';
import { useCoverEditor } from '../CoverEditorContext';
import { EffectsPanel } from './EffectsPanel';
import { LayersPanel } from './LayersPanel';
import { AiLocked } from './picture/AiLocked';
import { PicturePanel } from './PicturePanel';
import { TextPanel } from './TextPanel';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the cover editor; each part uses its own slice of it */
import styles from '../CoverEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The panel of the open tool (design cover-editor b1): the column next to the rail, or a bottom
 * sheet on a phone. On the Free plan the card "Get a picture made for your song" sits at the top of
 * every panel (owner request 2026-10-09), so the user always sees that a paid plan makes AI
 * pictures. A paid plan, the trial and the public tool (it has its own AI card) do not get it.
 */
const SidePanelComponent: React.FC = () => {
  const { tool, setTool, mode, data } = useCoverEditor();
  const isUpsellPinned = mode === 'song' && coverAiUpsellAlwaysShown(data.plan);
  const openBank = useCallback(() => setTool('picture'), [setTool]);
  const panel = (
    <>
      {tool === 'picture' && <PicturePanel />}
      {tool === 'text' && <TextPanel />}
      {tool === 'effects' && <EffectsPanel />}
      {tool === 'layers' && <LayersPanel />}
    </>
  );
  if (!isUpsellPinned) {
    return <section className={styles.pane}>{panel}</section>;
  }
  // The card stays above the panel; only the panel under it scrolls.
  return (
    <section className={clsx(styles.pane, styles.paneWithPin)}>
      {/* On the Picture panel of the Free plan the bank is the first tab: no bank link there. */}
      <AiLocked isPinned onOpenBank={tool === 'picture' ? undefined : openBank} />
      <div className={styles.paneBody}>{panel}</div>
    </section>
  );
};

export const SidePanel = TypedMemo(SidePanelComponent);
